import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PathParamService {
  private readonly partner: WritableSignal<string | null> = signal<
    string | null
  >(null);

  setPartnerParam(param: string) {
    this.partner.set(param);
  }

  getPartnerParam(): string | null {
    return this.partner();
  }

  clearPartnerParams() {
    this.partner.set(null);
  }
}
